<lib-modal
  #modal
  data-testid="bugticket-dialog"
  [appModalCloseGuard]="canClose"
  [closeLabel]="'general.close' | translate"
  [title]="(createdBug() ? 'bugticketDialog.titleCreated' : 'bugticketDialog.title') | translate"
  [subtitle]="
    createdBug()
      ? ('bugticketDialog.subtitleCreated' | translate: { provider: trackerLabel() })
      : ('bugticketDialog.subtitle' | translate)
  "
  [contentTemplate]="createdBug() ? success : formTemplate"
  [footerTemplate]="createdBug() ? done : actions"
  [visible]="open()"
  (cancel)="close()"
></lib-modal>

<ng-template #formTemplate>
  <form class="bugticket-dialog" [formGroup]="form" (ngSubmit)="submit()">
    @if (offersChoice()) {
      <div class="bugticket-dialog__target">
        <span class="bugticket-dialog__label" data-testid="bugticket-target-label">
          {{ 'bugticketDialog.targetLabel' | translate }}
        </span>
        <div class="bugticket-dialog__picker">
          <app-bug-target-picker [targets]="targets()" [locked]="submitting()" [(choice)]="choice" />
        </div>
      </div>
    }

    @if (request()?.sourceRef; as sourceRef) {
      <p class="bugticket-dialog__source" data-testid="bugticket-source">
        <span>{{ 'bugticketDialog.source' | translate }}</span>
        <code>{{ sourceRef }}</code>
      </p>
    }

    <mat-form-field appearance="fill" floatLabel="always" class="tc-field tc-field--uppercase-label">
      <mat-label>{{ 'bugticketDialog.titleLabel' | translate }}</mat-label>
      <input
        matInput
        formControlName="title"
        required
        data-testid="bugticket-title"
        [placeholder]="'bugticketDialog.titlePlaceholder' | translate"
        [attr.maxlength]="fieldLengths.NAME_MAX"
      />
    </mat-form-field>

    <mat-form-field appearance="fill" floatLabel="always" class="tc-field tc-field--uppercase-label">
      <mat-label>{{ 'bugticketDialog.descriptionLabel' | translate }}</mat-label>
      <textarea
        matInput
        rows="4"
        formControlName="description"
        data-testid="bugticket-description"
        [placeholder]="'bugticketDialog.descriptionPlaceholder' | translate"
        [attr.maxlength]="fieldLengths.FREETEXT_MAX"
      ></textarea>
    </mat-form-field>

    @if (error(); as failure) {
      <p class="bugticket-dialog__error" role="alert" data-testid="bugticket-error">
        {{ failure.key | translate: failure.params }}
        @if (failure.accountLink) {
          <a routerLink="/account">{{ toAccountKey | translate }}</a>
        }
      </p>
    }
  </form>
</ng-template>

<ng-template #success>
  @if (createdBug(); as bug) {
    <div class="bugticket-dialog__success" role="status">
      <span class="bugticket-dialog__success-mark"><mat-icon aria-hidden="true">check</mat-icon></span>
      <p class="bugticket-dialog__success-text">{{ 'bugticketDialog.success' | translate }}</p>
      <p class="bugticket-dialog__created">
        <span class="bugticket-dialog__created-label">
          {{ 'bugticketDialog.createdLabel' | translate: { provider: trackerLabel() } }}
        </span>
        <code data-testid="bugticket-created-key">{{ bug.key }}</code>
        <a data-testid="bugticket-created-link" target="_blank" rel="noopener noreferrer" [href]="bug.browseUrl">
          ↗ {{ 'bugticketDialog.open' | translate }}
        </a>
      </p>
      @if (!bug.attachmentsUploaded) {
        <p class="bugticket-dialog__attachments-missing" data-testid="bugticket-attachments-missing">
          {{ 'bugticketDialog.attachmentsMissing' | translate }}
        </p>
      }
    </div>
  }
</ng-template>

<ng-template #actions>
  <div class="bugticket-dialog__actions">
    <button type="button" lib-button variant="secondary" (click)="modal.onClose()">
      {{ 'bugticketDialog.cancel' | translate }}
    </button>
    <button type="button" lib-button variant="primary" icon="add" [disabled]="!canSubmit()" (click)="submit()">
      @if (submitting()) {
        {{ 'bugticketDialog.submitting' | translate }}
      } @else {
        {{ 'bugticketDialog.submit' | translate: { provider: trackerLabel() } }}
      }
    </button>
  </div>
</ng-template>

<ng-template #done>
  <div class="bugticket-dialog__actions">
    <button
      #doneButton
      type="button"
      lib-button
      variant="primary"
      icon="check"
      data-testid="bugticket-done"
      (click)="close()"
    >
      {{ 'bugticketDialog.close' | translate }}
    </button>
  </div>
</ng-template>
